import { motion } from 'framer-motion'

// Components
import { Button } from '@tracklib/kit'

// Utils
import { pageVariants } from 'components/interestform/utils'

import styles from './presentationoptions.css'

type PresentationOptionsProps = {
  setFieldValue: (field: string, value: boolean) => void
  handleSubmit: () => void
}

const PresentationOptions = (props: PresentationOptionsProps): JSX.Element => {
  const { setFieldValue, handleSubmit } = props

  const handleSkipPresentation = () => {
    setFieldValue('skipped_presentation', true)
    handleSubmit()
  }

  const handleResetSkipPresentation = () => {
    setFieldValue('skipped_presentation', false)
    handleSubmit()
  }

  return (
    <motion.div className={styles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={styles.heading}>What do you want to do?</h1>
      <div className={styles.buttonsWrapper}>
        <Button className={styles.button} variant="outline" onClick={() => handleResetSkipPresentation()}>
          Show me the slides
        </Button>
        <Button className={styles.button} variant="outline" onClick={() => handleSkipPresentation()}>
          Take me to the sign-up form
        </Button>
      </div>
    </motion.div>
  )
}

export default PresentationOptions
